export default __webpack_public_path__ + "static/media/spotify.4e7c5090.svg";